import React from 'react'
import {Link} from 'react-router-dom'
import classNames from 'classnames'
import DotLoader from '../DotLoader/DotLoader'

import './styles.css'

const RoundedBtn = props => {
    const {type = 'link', className, wide, tall, children, showLoading, minWidth = true, ...rest} = props

    const _className = classNames(className, "rounded-btn", {wide, tall, minWidth})

    switch (type) {
        case 'a':
            // eslint-disable-next-line jsx-a11y/anchor-has-content
            return <a className={_className} {...rest}>{children}</a>

        case 'link':
            return <Link className={_className} {...rest}>{children}</Link>

        case 'submit':
        case 'button':
            return <button type={type} className={_className} {...rest}>{showLoading ? <DotLoader height={16} /> : children}</button>

        default:
            console.error(`Invalid RoundedBtn type passed in props: ${type}`)
            return null
    }
}

export default RoundedBtn
